import { render, staticRenderFns } from "./CotacaoDetalhesCardHeader.vue?vue&type=template&id=7738f14e"
import script from "./CotacaoDetalhesCardHeader.vue?vue&type=script&lang=js"
export * from "./CotacaoDetalhesCardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports